import * as React from 'react'

import * as hooks from '@owl-nest/hooks'

export function SeoLink({ children, href }: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const isClientSide = hooks.useClientSide()

  if (isClientSide) {
    return <>{children}</>
  }

  return <a href={href}>{children}</a>
}
